import Progress from './progress';
export default Progress;


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_antd@3.0.2@antd/es/progress/index.js
// module id = 257
// module chunks = 0